$( document ).ready(function() {
  $('.product_single_slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  
  $('.product_buy-with_grid_items').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.prevq'),
    nextArrow: $('.nextq'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  
  
  
});


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



/*Custom Price Calc*/
$('body').on('change','.products_slider .product_slider_options select',function(){


  let product = JSON.parse($(this).parents('.product_single_slide').find('[type="application/json"]').text());
  let selectedVariant  = product.product.variants ;
  $( this ).parents('.product_slider_options').find('select').each(function(  ) {
    let option = $(this).val() ;
    selectedVariant  = selectedVariant.filter((variant , index)=>{  return variant.title.includes(option) == true});
  });

// Unavailable Product Price Hide
  if ($(".ProductForm__AddToCart").is(":disabled")){
    $('.Product__InfoWrapper').addClass('product_unavailable');
  }else {
    if ($('.Product__InfoWrapper').hasClass('product_unavailable')){
      $('.Product__InfoWrapper').removeClass('product_unavailable');
    }
  }
 
  $(this).parents('.FeaturedProduct__Info').find('.itemprice').html(Shopify.formatMoney(selectedVariant[0].price))
  $(this).parents('.ProductForm__Variants').find('[name="id"]').val(selectedVariant[0].id);
  
    var position_num =1;
    if($('#single_coll').length){
      position_num =1;
    }else{
      var splitText = $(this).val();
      const myArray = splitText.split(" ");
      var position_num = myArray[1];
    }
 
  var mds = $(this).closest('.product_single_slide').data('id');
  var class_define = '.slide-'+mds;

    var main_price = $(class_define+' .itemprice').text();
    main_price=main_price.trim();
    main_price=main_price.replace('$','');
    main_price=main_price.replace(',','');
    main_price=Math.round(main_price);
    var oprice=main_price;
     var coll_min_price=0;
  if(position_num == 1 ){
    coll_min_price = $('max_price_append_call_1').text();
    var url_set = $('.collection_url1').text();
    $('.collection_url_local').text(url_set);
    $(".custom_calc a.ProductForm__AddToCart.Button.Button--primary.Button--full").attr("href", url_set);
  }else if (position_num == 2) {
    var coll_min_price = $('.max_price_append_call_2').text();
    var url_set = $('.collection_url2').text();
    $('.collection_url_local').text(url_set);
    $(".custom_calc a.ProductForm__AddToCart.Button.Button--primary.Button--full").attr("href", url_set);
  }else if (position_num == 3) {
   
    coll_min_price = $('.max_price_append_call_2').text();
    var url_set = $('.collection_url3').text();
    $('.collection_url_local').text(url_set);
    $(".custom_calc a.ProductForm__AddToCart.Button.Button--primary.Button--full").attr("href", url_set);
  } 
    coll_min_price=coll_min_price.trim();
    coll_min_price=coll_min_price.replace('$','');
    coll_min_price=coll_min_price.replace(',','');
    coll_min_price=Math.round(coll_min_price);
    var total_price = coll_min_price + main_price;
    var tprice=total_price * $('.ProductForm__Variants .QuantitySelector__CurrentQuantity').val();
    $('.cbtnprice').text(' - $'+tprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    $(class_define+' .itemprice').text('$'+total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    $(class_define+' .sub_price').text('$'+total_price);
    $(class_define+' .sub_price').attr('data-oprice',oprice);
});


// Single Product Calc
$('body').on('click','.custom_calc .Popover__ValueList .Popover__Value',function(){
  // Unavailable Product Price Hide
  if ($(".ProductForm__AddToCart").is(":disabled")){
    $('.Product__InfoWrapper').addClass('product_unavailable');
  }else {
    if ($('.Product__InfoWrapper').hasClass('product_unavailable')){
      $('.Product__InfoWrapper').removeClass('product_unavailable');
    }
  }
  var position_num =1;
  if($('#single_coll').length){
     position_num =1;
  }else{
     splitText = $('.option-price-get .is-selected').text();
  //splitText = $(this).text();
   const myArray = splitText.split(" ");
   position_num = myArray[1];
  }
 
  setTimeout(function(){ 
    var main_price = $('.Product__InfoWrapper .ProductMeta__Price').text();
    main_price=main_price.trim();
    main_price=main_price.replace('$','');
    main_price=main_price.replace(',','');
    main_price=Math.round(main_price);
    var oprice=main_price;
    var coll_min_price=0;
  if(position_num == 1 ){
    coll_min_price= $('.max_price_append_call_1').text();
    var url_set = $('.collection_url1').text();
    $('.collection_url_local').text(url_set);
    $(".custom_calc a.ProductForm__AddToCart.Button.Button--primary.Button--full").attr("href", url_set);
  }else if (position_num == 2) {
    coll_min_price= $('.max_price_append_call_2').text();
    var url_set = $('.collection_url2').text();
    $('.collection_url_local').text(url_set);
    $(".custom_calc a.ProductForm__AddToCart.Button.Button--primary.Button--full").attr("href", url_set);
  }else if (position_num == 3) {
    coll_min_price= $('.max_price_append_call_3').text();
    var url_set = $('.collection_url3').text();
    $('.collection_url_local').text(url_set);
    $(".custom_calc a.ProductForm__AddToCart.Button.Button--primary.Button--full").attr("href", url_set);
  }
    coll_min_price=coll_min_price.trim();
    coll_min_price=coll_min_price.replace('$','');
    coll_min_price=coll_min_price.replace(',','');
    coll_min_price=Math.round(coll_min_price);
    var total_price = coll_min_price + main_price;
    var tprice=total_price * $('.ProductForm__Variants .QuantitySelector__CurrentQuantity').val();
    $('.cbtnprice').text(' - $'+tprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    $('.Product__InfoWrapper .ProductMeta__Price').text('$'+total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    $('.sub_price').text('$'+total_price);
    $('.sub_price').attr('data-oprice',oprice);
    }, 500);
});

$('body').on('change','.ProductForm__Variants .QuantitySelector__CurrentQuantity',function(){
  var qprice=$('.Product__InfoWrapper .ProductMeta__Price').text();
  qprice=qprice.trim();
  qprice=qprice.replace('$','');
  qprice=qprice.replace(',','');
  qprice=Math.round(qprice);
  qprice=qprice * $('.ProductForm__Variants .QuantitySelector__CurrentQuantity').val();
  $('.cbtnprice').text(' - $'+qprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
});
$('body').on('click','.QuantitySelector__Button',function(){
  var qprice=$('.Product__InfoWrapper .ProductMeta__Price').text();
  qprice=qprice.trim();
  qprice=qprice.replace('$','');
  qprice=qprice.replace(',','');
  qprice=Math.round(qprice);
  qprice=qprice * $('.ProductForm__Variants .QuantitySelector__CurrentQuantity').val();
  $('.cbtnprice').text(' - $'+qprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
});

$('body').on('click','.qqSelector .QuantitySelector__Button ',function(){
  var _ths = $(this);
  var crnt_value = _ths.parents('.ProductForm__QuantitySelector').find('[name="quantity"]').val();
  if(_ths.attr('data-action') == "increase-quantity"){
    crnt_value = parseInt(crnt_value)+1;
    _ths.parents('.ProductForm__QuantitySelector').find('[name="quantity"]').val(crnt_value);
  }else{
    if(crnt_value != '1'){
      crnt_value = crnt_value-1;
  _ths.parents('.ProductForm__QuantitySelector').find('[name="quantity"]').val(crnt_value);
    }
  }
});



$('body').on('click','.faq_popupopen',function(){

  let target = $(this).attr('data-id')
  $('.faq_popup[data-id="'+target+'"]').fadeIn(200)
  
});

$('body').on('click','.faq_popup_close',function(){

  $(this).parents('.faq_popup').fadeOut(200)
  
});




$('body').on('click','[action="add_product_que"]',function(e){
  e.preventDefault();

  var vv_id = $(this).parents('.product_single_slide').find('[name="id"]').val();
  var qty = $(this).parents('.product_single_slide').find('[name="quantity"]').val();

  var pdp_que = [{
    variantId: vv_id,
    Quantity: qty
  }]
  var collectaon_url = $('.collection_url_local').text();
  //var sub_price = $('.sub_price').text();
   var sub_price = $('.sub_price').attr('data-oprice');
  localStorage.setItem("max_price",sub_price);
  localStorage.setItem("max_collection",collectaon_url); 
  
  localStorage.setItem("pdp_que", JSON.stringify(pdp_que));
  window.location.href = $(this).attr('href')


});


$('body').on('click','[action="scent_add_to_que"]',function(e){
  e.preventDefault();

//   alert('sasa')
  
  var vv_id = $(this).parents('._item_controller').find('[name="id"]').val();
  var qty = $(this).parents('._item_controller').find('[name="quantity"]').val();

  var scent_que = [{
    variantId: vv_id,
    Quantity: qty
  }]

  localStorage.setItem("scent_que", JSON.stringify(scent_que));
  window.location.href = $(this).attr('href')


});




$('body').on('click','[action="view-detail"]',function(e){
  e.preventDefault();

  let url =  $(this).attr('href')

  $.ajax({
    type: 'GET',
    url: url,
    beforeSend: function() {

    },
    success: function(data) {    
      $('#product_view_poup').fadeIn() ;
      var filteredData = $(data).find(".product_popup");   
      $('#product_view_poup .product_view_poup_content').append(filteredData)        
    },
    dataType: "html"
  });

});


$('body').on('click','.product_view_poup_close',function(e){
  $('#product_view_poup').fadeOut() ;
  setTimeout(function(){
    $('#product_view_poup .product_view_poup_content').empty(); 
  }, 1000);

});


$('body').on('click','[action="cancle_request"]',function(e){
  window.history.back()
});


function addItemToCart(variant_id, qty) {

  let  data = {
    "id": variant_id,
    "quantity": qty
  }
  


  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      var dd = JSON.parse(localStorage.getItem("scent_que"));
          console.log(dd);
      if( typeof(dd) != 'undefined' && dd !=null )
      {

        let variant_id = dd[0].variantId ;
//         let qty = dd[0].Quantity  ;
         localStorage.removeItem("scent_que");
        addItemToCart(variant_id, qty)
      }
      else
      {
        window.location.href = '/cart'
      }
    }
  })
}

$('body').on('click','[action="Continue_request"]',function(e){

  var condition = true ;
  $( '.product_condition [type="checkbox"]' ).each(function( index ) {

    if($(this).is(":checked") == false)
    {
      $('.erroe_message_popup').fadeIn();
      condition = false ;
      return ;
    }
  })




  if(condition )
  {
    var cc = JSON.parse(localStorage.getItem("pdp_que"));

    if( typeof(cc) != 'undefined' && cc !=null )
    {

      let variant_id = cc[0].variantId ;
      let qty = cc[0].Quantity  ;
      localStorage.removeItem("pdp_que");
      addItemToCart(variant_id, qty)
   
    }
    else
    {
      
      var aa= JSON.parse(localStorage.getItem("scent_que"));

      if( typeof(aa) != 'undefined' && aa !=null )
      {
        
        let variant_id = aa[0].variantId ;
        let qty = aa[0].Quantity  ;
        localStorage.removeItem("scent_que");
        addItemToCart(variant_id, qty)

      }
    
    
    }
  }


});


$('body').on('click','[action="close_message"]',function(e){

 $('.erroe_message_popup').fadeOut();
});



$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on("load resize scroll",function(e){
if($('#product_term_form').length){
  if($('#product_term_form').isInViewport() )
  {
    console.log('yes')
  $('.skip_contant_arrow').hide()
  }
  else{
        console.log('no')
  $('.skip_contant_arrow').show()
  }
}
  
  
});

$('body').on('click','.skip_contant_arrow',function(e){
    $('html, body').animate({
        scrollTop: $("#product_term_form").offset().top - 200
    }, 1000);

});

    $('body').on('click','[action="scent_add_to_direct_cart"]',function(e){
 e.preventDefault();
     var vv_id = $(this).parents('._item_controller').find('[name="id"]').val();
  var qty = $(this).parents('._item_controller').find('[name="quantity"]').val();
console.log(vv_id);
  var scent_que = [{
    variantId: vv_id,
    Quantity: qty
  }]

  localStorage.setItem("scent_que", JSON.stringify(scent_que));

    var cc = JSON.parse(localStorage.getItem("pdp_que"));

    if( typeof(cc) != 'undefined' && cc !=null )
    {

      let variant_id = cc[0].variantId ;
      let qty = cc[0].Quantity  ;
      localStorage.removeItem("pdp_que");
      addItemToCart(variant_id, qty)
   
    }
    else
    {
      
      var aa= JSON.parse(localStorage.getItem("scent_que"));
//console.log(aa);
      if( typeof(aa) != 'undefined' && aa !=null )
      {
        
        let variant_id = aa[0].variantId ;
        let qty = aa[0].Quantity  ;
        localStorage.removeItem("scent_que");
        addItemToCart(variant_id, qty)

      }
    
    
    }
  


  });
  
